import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registrationAction } from '../../_actions';
import { PrivacyPolicyDialog, TermsOfUseDialog } from '../Profile';


class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    handlePrivacyPolicy = () => {
        const { dispatch } = this.props;
        dispatch(registrationAction.openPrivacyPolicy());
    }

    handleTermsOfUse = () => {
        const { dispatch } = this.props;
        dispatch(registrationAction.openTermsOfUse());
    }

    render() {
        return (
            <footer id="footer" className="no-print">
                <div className="empty-container"></div>
                <div className="container">
                    <a href="#" onClick={this.handlePrivacyPolicy}>Privacy Policy</a>
                    <a href="#" onClick={this.handleTermsOfUse}>Terms of Use</a>
                </div>
                <PrivacyPolicyDialog />
                <TermsOfUseDialog />
            </footer>
        );
    }
}


Footer.propTypes = {
    dispatch: PropTypes.func,
    openPrivacyPolicy: PropTypes.bool,
    openTermsOfUse: PropTypes.bool
};


function mapStateToProps(state) {
    const { openPrivacyPolicy, openTermsOfUse } = state.registration;    

    return {
        openPrivacyPolicy,
        openTermsOfUse
    };
}


const temp = connect(mapStateToProps)(Footer);

export { temp as Footer };